// extracted by mini-css-extract-plugin
export var homeGradient = "home-module--home-gradient--1ezNR";